/*
 * Module for one lonesome report
 */

//DataModel imported because we reqres it
define([
  "marionette",
  "backbone",
  "highcharts/highcharts",
  "jquery",
  "messaging/messenger",
  "modules/reportSplit/reports/singleReport/reportUtilities",
  "modules/reportSplit/reports/reportModel",
], function (_Marionette, Backbone, _Highcharts, $, Messenger, ReportUtilities) {
  "use strict";

  const ColumnReportShow = function (report, _renderTo, singleReportModule) {
    const clickAction = _clickActionAction(report);

    //general-purpose stuff
    if (report.type === "column") {
      let notSpecified = "";
      if (report.options.title === undefined) {
        notSpecified = "\ntitle";
      }
      if (report.options.seriesTitle === undefined) {
        notSpecified = notSpecified + "\nseriesTitle";
      }
      if (report.options.yAxisTitle === undefined) {
        notSpecified = notSpecified + "\nyAxisTitle";
      }
      if (notSpecified !== "") {
        Messenger.okDialog(
          "The following report options are required for column reports, but were not specified:\n" +
            notSpecified +
            "\n\nThey must be added to the report when it is created on the server.  The report will not be able to display until they are added.",
        );
        return;
      }
      /**
       * This report is the star of the group.  We begin with a bar chart again (and again, re-using the pie chart
       * reqres call). But the drilldown is what's really special.  Note that this is custom drilldown, unlike what
       * is common in the HighCharts demos. Drilldown here calls to the web server to get more data.  There are
       * other graphs here with more traditional drilldown.
       */
      let dataSet = Messenger.reqres.request("pieData", report.href);
      console.log(dataSet);
      singleReportModule.listenTo(
        dataSet,
        "sync",
        function () {
          //dataSet.once("sync", function() {
          //show the single report layout
          singleReportModule.showRegion(singleReportModule.layout);
          Messenger.vent.trigger("report:arrived", report);
          console.log(dataSet);
          dataSet = dataSet.toJSON();
          this.categories = dataSet[0].categories;

          dataSet = dataSet[0].data;
          const ids = dataSet[0].ids;

          console.log(dataSet);

          let currentTitle = $.t(report.options.title);
          currentTitle = ReportUtilities.figureOutText(currentTitle, true);
          let subTitleText = null;
          if (report.options.subTitle) {
            subTitleText = $.t(report.options.subTitle);
          }
          if (subTitleText !== null) {
            subTitleText = ReportUtilities.figureOutText(subTitleText, true);
          }
          const seriesTitle = $.t(report.options.seriesTitle);
          const yAxisTitle = $.t(report.options.yAxisTitle);
          let showDataLabels = true;
          if (report.options.showDataLabels) {
            showDataLabels = report.options.showDataLabels;
          }
          //our options are strings.  if the string is "false", convert it to false
          if (showDataLabels === "false") {
            showDataLabels = false;
          }

          for (let i = 0; i < this.categories.length; i++) {
            this.categories[i] = $.t(this.categories[i]);
          }

          const checkForData = function (dataSet) {
            for (let i = 0; i < dataSet[0].data.length; i++) {
              if (dataSet[0].data[i] !== 0) {
                return true;
              }
            }
            return false;
          };

          const hasData = checkForData(dataSet);
          //hasData ? alert(currentTitle + " has Data"):alert(currentTitle + " has No Data");
          if (!hasData) {
            subTitleText = $.t("reports.noData.long");
          }
          /**
           * In this case, it's unnecessary that this is a var.  With traditional drilldown, it's more helpful (as
           * can be seen elsewhere).
           */
          singleReportModule.createChart({
            chart: {
              type: "column",
            },
            title: {
              text: currentTitle,
            },
            subtitle: {
              text: subTitleText,
            },
            xAxis: {
              categories: this.categories,
            },
            yAxis: {
              title: {
                text: yAxisTitle,
                //text: 'Escalations'
              },
              allowDecimals: false,
            },
            series: [
              {
                name: seriesTitle,
                //name: 'Hits',
                data: dataSet[0].data,
              },
            ],
            /**
             * This begins where the magic happens.
             */
            plotOptions: {
              column: {
                cursor: "pointer",
                point: {
                  events: {
                    click: function () {
                      if (clickAction) {
                        let id;
                        if (ids) {
                          id = ids[this.index];
                        }
                        clickAction(this.category, id);
                      }
                    },
                  },
                },
                dataLabels: {
                  enabled: showDataLabels,
                  style: {
                    fontWeight: "bold",
                  },
                  formatter: function () {
                    return this.y;
                  },
                },
              },
            },
          }); //end highcharts
        },
        this,
      ); //end once.  must include this after the function, or it can't figure out how to get to
      // figureOutText.
    }
  };

  function _clickActionAction(report) {
    let clickAction = null;

    //report-specific stuff
    if (
      report.href === "/escalation/{startDate}/{endDate}/{touchpoint}/{language}" ||
      report.href === "/escalation/{startDate}/{endDate}/{language}?touchPointIds={touchpoint}"
    ) {
      clickAction = function (category) {
        /**
         * Parameter setup.  The Escalation Topic report needs to know which channel you want topics for - it's a
         * parameter. So, we need to set a handler for the topic here. Note that this handler isn't cleared
         * explicitly.  Rather, when the report area view is closed (which it is when a new report is shown), this
         * is cleaned up.  Although I'm not 100% sure that this will work with multiple drilldown - I'll find that
         * out fairly soon.
         */
        Messenger.vent.trigger("set:parameter", "escalation", category);
        /**
         * Another attribute of the dataSet for the pieChart reqres is the drillDownReport (which we get from the
         * reportModel).  Here, we retrieve that.
         */
        const ddReport = report.drillDownReport;
        /**
         * If a drilldown exists (which is should), we send out an event to show a new report.  "show:report" will
         * re-route back to the top of this showReport method, with the new report to show as the first parameter.
         * We also send the leaveExistingConfig view parameter as true (since later on, we won't want drilling down
         * to wipe out config settings).  The last parameter being true is really confusing right now and I need to
         * refactor that.  For now, setting it as true makes the drilldown show up.
         */

        if (ddReport) {
          if (window.location.hash.indexOf("reports") != -1) {
            for (let c = 0; c < ddReport.length; c++) {
              const currentDrillDown = ddReport[c];
              Messenger.vent.trigger("show:drilldown", currentDrillDown);
            }
            Messenger.vent.trigger("resize:charts");
          } else {
            var c = 0;
            const kbId = Messenger.reqres.request("active:kb");
            //setHandler only works if the report area is already up; it isn't, so set parameter manually
            let href = ddReport[c].href;
            //since we know the escalation type here, just set it manually in the href instead of trying
            //to get it from a reqres handler
            href = href.replace("{escalation}", category);
            const url = kbId + "/reports" + ReportUtilities.figureOutText(href);
            Backbone.history.navigate(url, { trigger: true });
          }
        }
      };
    }

    if (
      report.href === "/escalation/{startDate}/{endDate}/{touchpoint}/{language}/{escalation}" ||
      report.href ===
        "/escalationDrilldown/{startDate}/{endDate}/{language}/{escalation}?touchPointIds={touchpoint}"
    ) {
      clickAction = function (category, id) {
        Messenger.vent.trigger("set:parameter", "topic", id);
        Messenger.vent.trigger("set:parameter", "selectedTopicName", category);
        /**
         * For now, I put a third drilldown (which is the same as the scatterplot chart) in this one, to test my
         * layout's ability to display 3 charts. Soon, this will be refactored so it displays the table with
         * conversation details.
         */
        const ddReport = report.drillDownReport;
        if (ddReport) {
          for (let c = 0; c < ddReport.length; c++) {
            const currentDrillDown = ddReport[c];
            Messenger.vent.trigger("show:drilldown", currentDrillDown);
          }
        }
      };
      //if we're getting here from history, kludge the parameter
      if (report.fromHistory) {
        Messenger.vent.trigger(
          "set:parameter",
          2,
          "{touchpoint}",
          report.reportArguments[2].paramValue,
        );
        report.fromHistory = false;
      }
    }
    return clickAction;
  }

  return ColumnReportShow;
});
